/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { EventEdit, IEventEditOwnProps, IEventEditDispatchProps, IEventEditStateProps } from "../../components/event/eventEdit";
import { Base } from "ui/Scripts/source/framework/base";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IEventEditOwnProps): IEventEditStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.event) || Base.isNullOrUndefined(applicationState.event.eventEdit)) {
        return {
            item: null,
            createCompany: null,
            companies: [],
            units: [],
            eventSetting: null,
            urgencyClasses: [],
            eventTypeNodes: [],
            eventTypeBNodes: [],
            eventTypeCNodes: [],
            attachments: [],
            userCompanyId: "",
            userCode: "",
            userName: "",
            userPicture: "",
            canHandleEvent: false,
            canRemoveEvent: false,
            canSaveEvent: false,
            canEditIdentificationData: false,
            userIsIsSystemAdmin: false,
            returnUrl: ""
        };
    }
    const eventEdit = applicationState.event.eventEdit;
    return {
        item: eventEdit.item,
        createCompany: eventEdit.createCompany,
        companies: eventEdit.companies,
        units: eventEdit.units,
        urgencyClasses: eventEdit.urgencyClasses,
        eventSetting: eventEdit.eventSetting,
        eventTypeNodes: eventEdit.eventTypeNodes,
        eventTypeBNodes: eventEdit.eventTypeBNodes,
        eventTypeCNodes: eventEdit.eventTypeCNodes,
        attachments: eventEdit.attachments,
        userCompanyId: eventEdit.userCompanyId,
        userCode: eventEdit.userCode,
        userName: eventEdit.userName,
        userPicture: eventEdit.userPicture,
        canHandleEvent: eventEdit.canHandleEvent,
        canRemoveEvent: eventEdit.canRemoveEvent,
        canSaveEvent: eventEdit.canSaveEvent,
        canEditIdentificationData: eventEdit.canEditIdentificationData,
        userIsIsSystemAdmin: eventEdit.userIsIsSystemAdmin,
        returnUrl: eventEdit.returnUrl
    };
}

export function mapDispatchToProps(dispatch: storeEffects.EventThunkDispatch): IEventEditDispatchProps {
    return {
        loadEvent: (id: string) => dispatch(storeEffects.getEventEdit(id)),
        resetEvent: () => dispatch(storeActions.eventEditReset()),
        refreshEventLock: (id: string) => dispatch(storeEffects.refreshEventLock(id)),
    };
}

export default withRouter(connect<IEventEditStateProps, IEventEditDispatchProps, IEventEditOwnProps>(mapStateToProps, mapDispatchToProps)(EventEdit));